import { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import GenericModalNote from "../Modal/GenericModalNote";
import AppContext from "store/AppContext";
import FamilyService from "../../services/tfamily.service";
import Loader from "react-spinners/BarLoader";
const AddCollectiveMember = (props) => {
  const appContext = useContext(AppContext);
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const addMember = async ({ groupId, phoneNum, note }) => {
    try {
      setLoading(true);

      await FamilyService.addMember(groupId, phoneNum, note);
      props.notify(
        "tr",
        "success",
        `Хэрэглэгчийг коллектив групп руу амжилттай нэмлээ.`
      );
      await appContext.refreshConsumer();
    } catch (err) {
      props.notify("tr", "danger", err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      {loading ? <Loader /> : null}
      <Card.Header>
        <Card.Title as="h4">Гишүүн нэмэх</Card.Title>
      </Card.Header>

      <Card.Body>
        <Form>
          <Form.Group>
            <label>Member Phone Number</label>
            <Form.Control
              value={phone || ""}
              placeholder="Phone Number"
              type="number"
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            ></Form.Control>
          </Form.Group>
          <GenericModalNote
            onClick={addMember}
            params={{
              phoneNum: phone,
              groupId: props?.collective?.unitel?.groupId,
            }}
            action={"Группт нэмэх"}
            title={"Групп-т нэмэх"}
            body={`Та ${phone} дугаартай гишүүнийг ${props?.collective?.unitel?.groupId} групп руу нэмэхдээ итгэлтэй байна уу?`}
          />
        </Form>
      </Card.Body>
    </Card>
  );
};
export default AddCollectiveMember;
